module.exports = __webpack_public_path__ + "static/media/29DUNON7.077f54be.jpg";